<ui-card [headline]="headline$|async" [cardToolBarItems]="menuItems$|async" [isExpanded]="true">
  <div>
      <ui-table [data]="itemData$|async"
                (gridReady)="onGridReady($event)"
                [undoRedoCellEditing]="false"
                [enableRowAutoSave]="false"
                [enableSorting]="true"
                [enableFilter]="true"
                [suppressHorizontalScroll]="false"
                (rowClicked)="onRowClicked($event)"
                fxLayout="column"
                [id]="'confirmationDashboard'"
                #table>
          <ui-table-column
                  name="pointCd"
                  headerName="Location"
                  [editable]="false"
                  [hide]="!(itemLayout$ | async)?.pointCd">
          </ui-table-column>
          <ui-table-column
                  name="locationName"
                  headerName="Location Name"
                  [editable]="false"
                  [hide]="!(itemLayout$ | async)?.locationName">
          </ui-table-column>
          <ui-table-column
                  name="entityType"
                  headerName="Entity Type"
                  [editable]="false"
                  [hide]="!(itemLayout$ | async)?.entityType">
          </ui-table-column>
          <ui-table-column
                  name="entityName"
                  headerName="Entity Name"
                  [editable]="false"
                  [hide]="!(itemLayout$ | async)?.entityName">
          </ui-table-column>
          <ui-table-column
                  name="entityId"
                  headerName="Entity ID"
                  [editable]="false"
                  [hide]="!(itemLayout$ | async)?.entityId">
          </ui-table-column>
          <ui-table-column
                  name="recipientName"
                  headerName="Conf Pty"
                  [editable]="false">
          </ui-table-column>
      </ui-table>
  </div>
</ui-card>
